import React from 'react';

export const ContentHeading = ({ children }) =>
  <div className="content-section-heading text-center">
    {children}
  </div>;